export const shortenReferralLink = (referralLink: string): string => {
  if (!referralLink) return "";
  const referralLinkTextArray = referralLink.split("/");

  return referralLinkTextArray[referralLinkTextArray.length - 1];
};
